import { render, staticRenderFns } from "./AliyunUpload.vue?vue&type=template&id=cef2cfc2&"
import script from "./AliyunUpload.vue?vue&type=script&lang=js&"
export * from "./AliyunUpload.vue?vue&type=script&lang=js&"
import style0 from "./AliyunUpload.vue?vue&type=style&index=0&id=cef2cfc2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports